import type { TooltipProps } from "primereact/tooltip";

export const ARVORE_LABEL = "Distribuições e coletores";
export const ARVORE_COLUNA_NOME = "Distribuições e coletores";
export const ARVORE_COLUNA_PERCENTUAL = "Percentual";
export const ARVORE_COLUNA_ALTERACAO = "Última alteração";

export const ARVORE_EXPANDIR = "Expandir";
export const ARVORE_RECOLHER = "Recolher";

export const ARVORE_TOOLTIP_OPTIONS: TooltipProps = { position: "top", event: "hover" };
